import { appLogger } from "../logger";

export const getDateTimeRange = (UTCDate: any) => {
  if (UTCDate > 0) {
    let dateString = new Intl.DateTimeFormat("en-US")
      .format(new Date(UTCDate))
      .toString()
      .replace(/\s/g, "-");
    const timeString = new Date(
      UTCDate + new Date().getTimezoneOffset() * -60 * 1000
    )
      .toISOString()
      .slice(0, 19);
    dateString = `${timeString}`;
    appLogger.info({
      infoObj: {
        method: "getDateTimeRange",
        component: "data",
        fileName: "datatime.tsx",
        UTCDate: UTCDate,
      },
    });
    return dateString;
  }
  return "";
};

export const getDateTime = (UTCDate: any) => {
  let dateString = new Intl.DateTimeFormat("en-US", {
    // year: "2-digit",
    // month: "short",
    // day: "2-digit",
  })
    .format(new Date(UTCDate))
    .toString()
    .replace(/\s/g, "-");
  const timeString = new Date(UTCDate).toTimeString().substring(0, 8);

  dateString = `${dateString}, ${timeString}`;

  return dateString;
};

export const getDelayDate = (date: any) => {
  const dateString = new Intl.DateTimeFormat("en-IN", {
    month: "short",
    day: "2-digit",
  })
    .format(new Date(date))
    .toString()
    .replace(/\s/g, " ");

  return dateString;
};

export const getDate = (UTCDate: any) => {
  const dateString = new Intl.DateTimeFormat("en-US", {
    // year: "numeric",
    // month: "short",
    // day: "2-digit",
  })
    .format(new Date(UTCDate))
    .toString()
    .replace(/\s/g, "-");

  return dateString;
};

export const getFullDate = (date: any) => {
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "short" });
  const day = ("0" + date.getDate()).slice(-2);
  const dateformat = `${day} ${month} ${year}`;

  return dateformat;
};

export const getUTCDate = (UTCDate: any) => {
  const year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
    UTCDate
  );
  const month = new Intl.DateTimeFormat("en", { month: "numeric" }).format(
    UTCDate
  );
  const date = new Intl.DateTimeFormat("en", { day: "numeric" }).format(
    UTCDate
  );
  const dateInUTC = Date.UTC(
    parseInt(year),
    parseInt(month) - 1,
    parseInt(date)
  );

  return dateInUTC;
};

export const getTime = (milliseconds: any) => {
  const hours = `0${new Date(milliseconds).getHours() - 1}`.slice(-2);
  const minutes = `0${new Date(milliseconds).getMinutes()}`.slice(-2);
  const seconds = `0${new Date(milliseconds).getSeconds()}`.slice(-2);

  const time = `${hours}:${minutes}:${seconds}`;

  return time;
};

export const getDateString = (timestamp: any) => {
  const dt = new Date(timestamp);
  const year = dt.getFullYear();
  const month = String(dt.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
  const day = String(dt.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
